var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"abstract-1",attrs:{"src":require('@/assets/abstract1.png'),"height":"528","width":"613"}})}
var staticRenderFns = []

export { render, staticRenderFns }